import '../styles/Map.scss';
import { useEffect, useRef, useState } from "react";
import { 
    Warning, 
    WarningDiamond,
    Fire, 
    MapPinArea, 
    BellSimpleRinging, 
    User,
    UsersThree,
    Cloud,
    CellTower
} from "@phosphor-icons/react";
import FirePopup from './panels/Fires/FirePopUp.js';
import PredictionsPage from './panels/Predictions/PredictionsPage.js';
import PredictionPopup from './panels/Predictions/PredictionPopup.js';
import SensorData from './panels/SensorData/SensorData.js';
import SensorDataPopup from './panels/SensorData/SensorDataPopup.js';
import MapLayers from './panels/MapLayers/MapLayers.js';
import CreateArea from './panels/Areas/CreateArea/CreateArea.js';
import Pool from '../UserPool';
import { useNavigate } from 'react-router-dom';
import SearchedLocation from './panels/SearchedLocation/SearchedLocation.js';
import Account from './panels/Account/Account.js';
import Tab from './Tab.js';
import { SignOut } from "@phosphor-icons/react";
import ForecastMenu from './panels/Forecast/ForecastMenu.js';
import RAWSPage from './panels/RAWS/RAWSPage.js';
import RAWSPopUp from './panels/RAWS/RAWSPopUp.js';
import Legend from './panels/Legend/Legend.js';
import pinEnabled from '../assets/icons/pin-enabled.png';
import pinDisabled from '../assets/icons/pin-disabled.png';
import Help from './panels/Help/Help.js';
import FiresPage from './panels/Fires/FiresPage.js';
import Alerts from './panels/Alerts/Alerts.js';
import AreasPage from './panels/Areas/AreasPage.js';
import AddFire from './panels/Fires/AddFire/AddFire.js';
import FiresModal from './panels/Fires/Modals/FiresModal.js';
import { useFiresContext } from '../contexts/FiresContext.js';
import { useUserContext } from '../contexts/UserContext.js';
import CreateAndMonitor from './panels/CreateAndMonitor/CreateAndMonitor.js';
import HistoricalFirePopup from './panels/Fires/HistoricalFirePopUp.js';
import EditFire from './panels/Fires/EditFire/EditFire.js';
import TeamsPage from './panels/Teams/TeamsPage.js';
import HighPriorityPage from './panels/HighPriority/HighPriorityPage.js';
import axios from 'axios';

export default function Sidebar(props) {
    const {
        modal,
        setModal
    } = useFiresContext();

    const {
        getToken,
        logout
    } = useUserContext();

    const {
        panel, 
        setPanel, 
        config, 
        setConfig, 
        areas, 
        setAreas,
        map, 
        user,
        setUser,
    } = props;

    const [tab, setTab] = useState(panel.name);
    const navigate = useNavigate();
    const sidebar = useRef();
    const panelRef = useRef();
    const [expand, setExpand] = useState(false);
    const [pinned, setPinned] = useState(true);
    const [highPriorityFires, setHighPriorityFires] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTab(panel.name);
    }, [panel]);

    useEffect(() => {
        if (expand) sidebar.current.style.width = '200px';
        else sidebar.current.style.width = '50px';
    }, [expand]);

    useEffect(() => {
        if (panel.name !== 'Empty') {
            panelRef.current.style.minWidth = '400px';
            panelRef.current.style.width = 'auto';
        } else {
            panelRef.current.style.minWidth = '0px';
            panelRef.current.style.width = '0px';
        }
    }, [pinned, panel]);

    const getHighPriorityFires = () => {
        setLoading(true);

        getToken().then((token) => {
            axios
            .get('https://firewatch-api.space-eyes.com/confirmed-alerts', {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
                const rows = response.data.alerts;
                const fireMap = new Map();

                rows.forEach((row) => {
                const {
                    fire_id,
                    name,
                    latitude,
                    longitude,
                    data_source,
                    distance,
                    geom,
                    area_value,
                    perContained,
                    active,
                    areaAC,
                    updatedTimestamp,
                    area_name,
                } = row;
    
                if (!fireMap.has(fire_id)) {
                    fireMap.set(fire_id, {
                        fire_id,
                        name,
                        geom,
                        latitude,
                        longitude,
                        data_source,
                        distance,
                        perContained,
                        active,
                        areaAC,
                        updatedTimestamp,
                        areas: [],
                    });
                }
    
                fireMap.get(fire_id).areas.push({
                    area_name: area_name,
                    distance: distance,
                    value: area_value
                });
                });
    
                const grouped = Array.from(fireMap.values());

                const deduped = grouped.map((fire) => {
                  const seen = new Set();
                  const uniqueAreas = fire.areas.filter((area) => {
                    if (seen.has(area.area_name)) return false;
                    seen.add(area.area_name);
                    return true;
                  });
                  return { ...fire, areas: uniqueAreas };
                });
                
                setHighPriorityFires(deduped);
                setLoading(false);
            })
            .catch((error) => {
                console.log('error getting fires', error);
                setLoading(false);
            });
        });
    };
    
    useEffect(() => {
        getHighPriorityFires();
    }, []);

    const tabs = [
        {
            name: 'High Priority',
            icon: Warning
        },
        {
            name: 'Fires',
            icon: Fire
        },
        {
            name: 'Monitoring Areas',
            icon: MapPinArea
        },
        {
            name: 'Predictions',
            icon: WarningDiamond
        },
        {
            name: 'Alerts',
            icon: BellSimpleRinging
        },
        {
            name: 'Teams',
            icon: UsersThree
        },
        {
            name: 'Forecast',
            icon: Cloud
        },
        {
            name: 'RAWS',
            icon: CellTower
        },
        // {
        //     name: 'Sensor Data',
        //     icon: sensorIcon
        // },
        // {
        //     name: 'Help',
        //     icon: questionMarkIcon
        // },
    ];

    const stageSwitch = (tab) => {
        switch (tab) {
            case 'Empty': return <></>
            case 'High Priority': 
                return (
                    <HighPriorityPage panel={panel} setPanel={setPanel} user={user} setUser={setUser} map={map} highPriorityFires={highPriorityFires} setHighPriorityFires={setHighPriorityFires} getHighPriorityFires={getHighPriorityFires} loading={loading}/>
                )
            case 'Account': 
                return (
                    <Account panel={panel} setPanel={setPanel} user={user} setUser={setUser} map={map} config={config} setConfig={setConfig} modal={modal} setModal={setModal} getToken={getToken}/>
                )
            case 'Monitoring Areas': 
                return (
                    <AreasPage setPanel={setPanel} panel={panel} user={user} areas={areas} setAreas={setAreas} map={map} config={config} setConfig={setConfig} setModal={setModal} />
                )
            case 'Predictions': 
                return (
                    <PredictionsPage panel={panel} setPanel={setPanel} user={user} map={map} />
                )
            case 'Prediction PopUp': 
                return (
                    <PredictionPopup setPanel={setPanel} prediction={panel.content} user={user}/>
                )
            case 'Fires': 
                return (
                    <FiresPage panel={panel} setPanel={setPanel} user={user} setUser={setUser} map={map} />
                )
            case 'Fire PopUp': 
                return (
                    <FirePopup map={map} setPanel={setPanel} fire={panel.content} panel={panel} user={user} setUser={setUser}/>
                )
            case 'Historical Fire PopUp': 
                return (
                    <HistoricalFirePopup map={map} setPanel={setPanel} fire={panel.content} panel={panel} user={user} setUser={setUser}/>
                )
            case 'Add Fire': 
                return (
                    <AddFire map={map} setPanel={setPanel} panel={panel} fire={panel.content} user={user} setUser={setUser} setPinned={setPinned}/>
                )
            case 'Edit Fire': 
                return (
                    <EditFire map={map} setPanel={setPanel} panel={panel} fire={panel.content} user={user} setUser={setUser} />
                )
            case 'Teams': 
                return (
                    <TeamsPage modal={modal} setModal={setModal} user={user}/>
                )
            case 'Alerts': 
                return (
                    <Alerts modal={modal} setModal={setModal} user={user}/>
                )
            case 'Forecast': 
                return (
                    <ForecastMenu map={map}/>
                )
            case 'Map Layers': 
                return (
                    <MapLayers panel={panel} setPanel={setPanel} user={user} map={map}/>
                )
            case 'Create and Monitor': 
                return (
                    <CreateAndMonitor map={map} setPanel={setPanel}n/>
                )
            case 'RAWS': 
                return (     
                    <RAWSPage panel={panel} setPanel={setPanel} user={user} map={map} />
                )
            case 'RAWS - Singular': 
                return (
                    <RAWSPopUp panel={panel} setPanel={setPanel} user={user} map={map}/>
                )
            case 'Monitoring Areas - Create': 
                return (
                    <CreateArea setPanel={setPanel} panel={panel} user={user} map={map} setPinned={setPinned}/>
                )
            case 'Sensor Data': 
                return (
                    <SensorData areas={areas} setAreas={setAreas} panel={panel} setPanel={setPanel} user={user} map={map} />
                )
            case 'Sensor Data Popup': 
                return (
                    <SensorDataPopup setPanel={setPanel} data={panel.content} user={user}/>
                )
            case 'Searched Location': 
                return (
                    <SearchedLocation panel={panel} setPanel={setPanel} user={user} map={map}/>
                )
            case 'Legend': 
                return (
                    <Legend />
                )
            case 'Help': 
                return (
                    <Help panel={panel} setPanel={setPanel} user={user} map={map}/>
                )
            default: return <></>
        }
    }

    const signOut = async () => {
        logout();
        navigate('/login');
        setPanel({
            name: 'Empty',
            content: null
        });
        // setArea({
        //     area_id: 1751,
        //     user_id: -1,
        //     area_name: "United States",
        //     area_description: "",
        //     geom: "0103000020E61000000100000004000000149598D04F5A59C07CEC6BB65F844340A08CA4F5CE7159C00C65EC0DE6D24240C4563D93A71B59C06605A2D4C0D44240149598D04F5A59C07CEC6BB65F844340",
        //     area_size_meters_squared: 0,
        //     created_timestamp: "2024-08-22 17:55:04.802192",
        //     zoom: 4,
        //     is_default: false,
        //     active: false,
        //     wkt: wkt,
        //     bounds: '-125.0,24.396308,-66.93457,49.384358'
        // });
    }

    return (
        <div className='sidebar-container'>
            {(modal.type) && 
            <FiresModal
                map={map}
                panel={panel}
                setPanel={setPanel}
            />}
            <div 
                className='sidebar' 
                ref={sidebar} 
                onMouseOver={() => setExpand(true)} 
                onMouseOut={() => setExpand(false)}
                onMouseEnter={() => {
                    if (panel.name !== 'Empty') {
                        panelRef.current.style.minWidth = '400px';
                        panelRef.current.style.width = 'auto';
                    }
                }}
                >
                <div className='sidebar-top'>
                    <div className='sidebar-top-account' onClick={() => setPanel({name: 'Account', content: null})}>
                        <User size={24} className='sidebar-top-account-icon'/>
                        <div className='sidebar-top-account-text'>
                            <div className='sidebar-top-account-text-name'>{user.idToken.payload.name}</div>
                            <div className='sidebar-top-account-text-plan'>{`${config.subscription_type.charAt(0).toUpperCase() + config.subscription_type.slice(1)} Plan`}</div>
                        </div>
                    </div>
                </div>
                <div className='sidebar-tabs'>
                    {
                        tabs.map((tab, index) => <Tab key={index} tab={tab} mainExpand={expand} panel={panel} setPanel={setPanel}/>)
                    }
                </div>
                <div className='sidebar-bottom'>
                    <div className='sidebar-bottom-signout' onClick={signOut}>
                        <SignOut size={24} className='sidebar-bottom-signout-icon'/>
                        <div className='sidebar-bottom-signout-text'>Sign Out</div>
                    </div>
                </div>
            </div>
            <div 
                ref={panelRef} 
                className='map-controls-settings-window'
                onMouseLeave={() => {
                    if (!pinned) {
                        panelRef.current.style.minWidth = '0px';
                        panelRef.current.style.width = '0px';
                    };
                }}
                >
                <img 
                    src={pinned ? pinEnabled : pinDisabled} 
                    className='map-controls-settings-window-pin-icon'
                    onClick={() => setPinned((prevState) => !prevState)}
                    style={{ filter: 'invert(100%)' }}
                />
                {stageSwitch(tab)}
            </div>
        </div>
    );
}